import React from "react";
import { Collapse, Flex, Space } from "antd";
import { BookingTransactionDetails, BookingAddOns } from "../../../interfaces/booking.interface";
import { currencyDisplay } from "../../../utils/helpers";

const PricingSummary2 = (
  props: {
    summary: BookingTransactionDetails;
    addOns?: BookingAddOns[];
    showAdminFee: boolean;
    currencyAdminFee: string;
    currencyGrandTotal: string;
    currencyAddOnsTotal: string;
    showNonMalaysiaCharge?: boolean;
    currencyNonMalaysiaCharges?: string;
    showVisaFee?: boolean;
    currencyVisaFee?: string;
    cabin?: number;
    depositPaymentSelected?: boolean;
    currencyDeposit?: string;
    dueDate?: string;
    currencyBalance?: string;
  }
) => {
  const {
    summary,
    addOns = [],
    showAdminFee,
    currencyAdminFee,
    currencyGrandTotal,
    currencyAddOnsTotal,
    showNonMalaysiaCharge = false,
    currencyNonMalaysiaCharges = "",
    showVisaFee = false,
    currencyVisaFee = "",
    cabin,
    depositPaymentSelected = false,
    currencyDeposit,
    dueDate,
    currencyBalance
  } = props;

  // Build add-ons collapse items
  const addOnsCollapseItems = addOns.length > 0 ? [{
    key: 'add-ons',
    label: (
      <div className="pricing-summary-booking-details-items">
        <span>Add ons</span>
        <span>+ {currencyAddOnsTotal}</span>
      </div>
    ),
    children: (
      <div className="pricing-summary-addons-details">
        {addOns.map((addon, index) => (
          <div key={index} className="pricing-summary-booking-details-items">
            <span>{addon.label} </span>
            <span>+ {currencyDisplay(summary?.priceCurrency, addon.value.toFixed(2))} x {addon.totalPax} </span>
          </div>
        ))}
      </div>
    )
  }] : [];


  return (
    <div className="pricing-summary-v2">
      <Flex vertical className="pricing-summary-booking-details">
        {
          cabin && (
            <div className="pricing-summary-booking-details-items highlight">
              <span> Cabin </span>
              <span> x {cabin} </span>
            </div>
          )
        }

        {
          summary?.fareBreakdown?.items?.length > 0 && (
            <div className="pricing-summary-booking-details-breakdown">
              {
                summary?.fareBreakdown?.items.map((item: { category: string; count: number; sum: number }, index) => (
                  item.category && (    
                      <div key={index} className="pricing-summary-booking-details-items">
                        <span> {item.category} </span>
                        <span>{currencyDisplay(summary.priceCurrency, item.sum)} x {item.count} </span>
                      </div>
                  )
                ))
              }

              {
                addOnsCollapseItems.length > 0 && (
                  <Collapse 
                    items={addOnsCollapseItems}
                    accordion
                    bordered={false}
                    className=""
                  />
                )
              }


              {
                showNonMalaysiaCharge && currencyNonMalaysiaCharges && (
                  <div className="pricing-summary-booking-details-items">
                    <span>Non-Malaysian Charge</span>
                    <span>{currencyNonMalaysiaCharges}</span>
                  </div>
                )
              }

              {
                showVisaFee && currencyVisaFee && (
                  <div className="pricing-summary-booking-details-items">
                    <span>Visa Fee</span>
                    <span>- {currencyVisaFee}</span>
                  </div>
                )
              }

              {
                (showAdminFee) && (
                  <div className="pricing-summary-booking-details-items">
                    <span>Admin Fee</span>
                    <span>{currencyAdminFee} </span>
                  </div>
                )
              }
              <div className="pricing-summary-booking-details-total">
                {
                  depositPaymentSelected && (
                    <div className="deposit-highlight">
                      <Space size="small" style={{ display: "flex"}} direction="vertical">
                        <Flex gap={5} align="center" justify="space-between">
                          <span>Deposit</span>
                          <span>-{currencyDeposit}</span>
                        </Flex>
                        <Flex gap={5} align="center" justify="space-between" className="due-date">
                          <span>Due Date</span>
                          <span>{dueDate}</span>
                        </Flex>
                        
                        <Flex gap={5} align="center" justify="space-between" className="balance">
                          <span>Remaining Balance</span>
                          <span>{currencyBalance}</span>
                        </Flex>
                        
                      </Space>
                    </div>
                  )
                }

                <div className="grand-total">
                  <span>Total</span>
                  <span>{currencyGrandTotal}</span>
                </div>
              </div>
            </div>
          )
        }    
      </Flex>
    </div>
  )
}

export default PricingSummary2;